import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DeliveryNotePartiesInitialState, DeliveryNotePartiesLoad } from './delivery-note-parties.actions';
import { DeliveryNotePartiesService } from './delivery-note-parties.service';
import { DeliveryNotePartiesModel } from '../../models';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { NotificationService } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface DeliveryNotePartiesStateModel {
  parties: DeliveryNotePartiesModel[];
  loaded: boolean;
}

const initialState: DeliveryNotePartiesStateModel = {
  parties: [],
  loaded: false,
};

@State<DeliveryNotePartiesStateModel>({
  name: 'deliveryNoteParties',
  defaults: initialState,
})
@Injectable()
export class DeliveryNotePartiesState {
  constructor(
    private deliveryNotePartiesService: DeliveryNotePartiesService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: DeliveryNotePartiesStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getParties(state: DeliveryNotePartiesStateModel): DeliveryNotePartiesModel[] {
    return state.parties;
  }

  @Action(DeliveryNotePartiesLoad)
  getDeliveryNoteParties(
    ctx: StateContext<DeliveryNotePartiesStateModel>,
    { payload }: DeliveryNotePartiesLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.deliveryNotePartiesService.getParties(payload).pipe(
      map((parties: DeliveryNotePartiesModel[]) => {
        ctx.patchState({ parties, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DeliveryNotePartiesInitialState)
  setInitialState(ctx: StateContext<DeliveryNotePartiesStateModel>): void {
    ctx.setState(initialState);
  }
}
